import { Navigate } from "react-router-dom";
import { useCapabilities } from "./useCapabilities";

const CapabilityRoute = ({ requires = [], children }) => {
  const { capabilities, isLoading } = useCapabilities();

  if (isLoading) return null;

  const ok = requires.some((c) => capabilities.includes(c));

  if (!ok) return <Navigate to="/" replace />;

  return children;
};

export default CapabilityRoute;
